<section
	class="bg-surface-50 dark:bg-surface-950 px-6 py-20 md:px-12 lg:px-20 flex lg:flex-row flex-col gap-12 justify-center items-center">
	<div class="flex-1">
		<app-headline-large
			[title]="content.title"
			class="mb-4"></app-headline-large>
		<app-body-large
			[description]="content.description"
			class="mb-8"></app-body-large>
		@if (content.link){
		<app-link
			[type]="content.link.type"
			[label]="content.link.title"
			[routerLink]="content.link.path"
			bgColor="light"></app-link>
		}
	</div>
	@if (content.copy.length > 0){
	<div class="flex-1 flex flex-col">
		@for (item of content.copy; track item.title; let last = $last) {
		<div
			pAnimateOnScroll
			enterClass="animate-enter fade-in-10 slide-in-from-t-20 animate-duration-1000"
			class="flex gap-6">
			<div class="flex flex-col items-center">
				<div
					class="bg-primary-500 w-14 h-14 flex items-center justify-center border border-surface-200 dark:border-surface-700">
					<span><i class="pi pi-check-circle text-base! leading-none! text-surface-0"></i></span>
				</div>
				@if (!last) {
				<div class="w-px flex-1 bg-primary-500 dark:bg-surface-700"></div>
				}
			</div>
			<div>
				@if (item.title.length > 0){
				<h3
					class="text-lg leading-tight font-semibold mb-2 text-surface-900 dark:text-surface-200"
					[innerHTML]="item.title"></h3>
				} @if (item.description.length > 0){
				<app-body-large [description]="item.description"></app-body-large>
				}
			</div>
		</div>
		@if (!last) {
		<div
			pAnimateOnScroll
			enterClass="animate-enter fade-in-10 slide-in-from-t-20 animate-duration-1000"
			class="flex flex-col items-center w-14 h-14">
			<div class="w-px flex-1 bg-primary-500 dark:bg-surface-700"></div>
			<div class="w-px flex-1 bg-primary-500 dark:border-surface-700"></div>
			<div class="w-px flex-1 bg-primary-500 dark:bg-surface-700"></div>
		</div>
		} }
	</div>
	}
</section>
